/* tslint:disable */

import { Component, Inject, LOCALE_ID, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SignUpComponent } from '../pages/sign-up/sign-up.component';
import { userprofile } from '../shared/classes/userprofile';
import { NaviFreshMartService } from 'src/app/shared/services/navi-fresh-mart.service';
import { cart } from '../shared/classes/cart';
import { Router } from '@angular/router';
import { Stall } from './../shared/classes/stall';
import { DataService } from './../shared/services/data.service';
import { AuthService } from '@auth0/auth0-angular';
import { Browser } from '@capacitor/browser';
import { switchMap } from 'rxjs/operators';
import { formatDate } from '@angular/common';
import { callbackUri } from '../auth.config';
import { Capacitor } from '@capacitor/core';
import { Camera } from '@capacitor/camera';
import { Orders } from '../shared/classes/orders';
import { Location } from '@angular/common';
import { NavService } from '../shared/services/nav.service';
import { StatusBar, BackgroundColorOptions, Style } from '@capacitor/status-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'app-newlandscreen',
  templateUrl: './newlandscreen.component.html',
  styleUrls: ['./newlandscreen.component.scss']
})
export class NewlandscreenComponent implements OnInit {

  showContent: boolean = true;
  selectedTabIndex = 0;
  userForm: FormGroup;
  carouselImages = [
    '.\assets\images\Foods\Burger1.jpg',
    '\assets\images\Foods\Dish2.jpg',
    '\assets\images\Foods\Roll1.jpg'
  ];
  personalimg = '.\assets\images\Foods\Burger1.jpg';
  corporateimg = '.\assets\images\signup_corporate_img.png';
  splashscreen = '../../assets/images/genieImages/mfg_splashscreen.svg'

  carouselItems = [
    // { image: './assets/images/genieImages/slide_1.png',
    //   heading: 'Navifoodmart Vending Machines',
    //   caption: 'Ease your purchases without waiting in Queues using your mobile'},

    // { image: './assets/images/genieImages/slide_2.png',
    //   heading: 'Navifoodmart Items',
    //   caption: 'Wide variety of items to choose'},

    //   { 
    //     image: './assets/images/genieImages/slide_3.png',
    //   heading: 'Navifoodmart Cafeteria',
    //   caption: 'Makes your cafeteria available on mobile for order skipping the queues'
    // },
    // { image: './assets/images/genieImages/slide_4.png',
    //   heading: 'Navifoodmart Payments',
    //   caption: 'Make your purchases cashless with Food wallets and UPI'
    // },
    {
      image: './assets/images/genieImages/step1.svg',
      heading: 'Step1',
      caption: 'Select your favourite food items'
    },

    {
      image: './assets/images/genieImages/step2.svg',
      heading: 'Step2',
      caption: 'Scan and pay'
    },

    {
      image: './assets/images/genieImages/step3.png',
      heading: 'Step3',
      caption: 'Get your favourite items'
    }

    // Add more slides here
  ];

  isNewUser: boolean = false;
  isOtpSent: boolean = false;
  isLogin: boolean = false;
  isMobile: boolean = false;
  isCorporateLogin: boolean = false;
  isResendOtp = false;
  interval;
  timeLeft: number = 60;
  isOtpVerified = false;
  isMobileValid = true;
  isEmailValid = true;
  isNameValid = true;
  isOtpValid = true;
  isSubmitted = false;
  isConditionsAccepted;
  currentUser: any = {
    mobileNumber: undefined,
    password: undefined,
    name: undefined,
    email: undefined,
    otp: undefined,
    password1: undefined,
    mobileemail: undefined,
    accountId: undefined,
    role: undefined,
  };
  stallCode;
  isStallCodeValid: 'found' | 'invalid' | null = null;
  genieList: Stall[] = [];
  isMobileOrDesktop: boolean = false;
  modalReference: any;
  linePosition: number = 0;
  ngClassForButtons = "openCamera";
  qrCodeResult: string = '';
  orderDetails: Orders;
  isContainerVisible: boolean = false;
  lastSegment: string;
  segmentId: number;
  Mobilenumber: any;
  loading: boolean = false;
  constructor(private fb: FormBuilder,
    private modalService: NgbModal,
    private naviService: NaviFreshMartService,
    private router: Router,
    private dataService: DataService,
    private auth: AuthService,
    @Inject(LOCALE_ID) public locale: string,
    private renderer: Renderer2,
    private location: Location,
    private navService: NavService,
    private _snackBar: MatSnackBar,) {

  }
  carouselOptions = {
    items: 1,
    autoplay: true,
    loop: true,
    dots: true,
    autoplaySpeed: 900,
    nav: false,
    responsive: {
      768: {
        items: 1
      },
      1024: {
        items: 1
      }
    }
  };
  loggeedUser$ = this.auth.isAuthenticated$.pipe(switchMap(() => this.auth.user$));
  usersList = [];

  ngOnInit(): void {

    if (Capacitor.getPlatform() === "ios") {
      StatusBar.setStyle({ style: Style.Light });
    }
    else {
      this.setStatusBarBackgroundColor('#ffffff');
      // StatusBar.setStyle({ style: Style.Light });
    }


    this.userForm = new FormGroup({
      mobileNumber: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{10}$')]),
      fName: new FormControl('', [Validators.required, Validators.minLength(1)]),
      email: new FormControl('', [Validators.required, Validators.email]),
      otp: new FormControl(),
    });
    const subPaths = this.router.url.split('/');
    const lastSegment = subPaths[subPaths?.length - 2];
    const segmentId = subPaths[subPaths?.length - 1];
    this.lastSegment = lastSegment;

    if (!isNaN(Number(segmentId))) {
      this.segmentId = parseInt(segmentId);
      this.showContent = true;
    }
    else {
      console.log('ss', this.showContent);
      this.showContent = false;
    }



    if (localStorage.getItem('user') && localStorage.getItem('loginType')) {


      this.dataService.machineId$.subscribe((genieId) => {
        if (genieId != 0) {
          console.log("genie land", genieId);
          this.router.navigate([`shop/machine-prod-items`], { skipLocationChange: true });
        }
        else {
          this.router.navigate(['shop/mfg-land'], { skipLocationChange: true }); // Replace '/other-page' with the desired route
        }
      })


    }
    console.log("sc", this.showContent);
    // this.naviService.getMachines().subscribe((data)=>{
    //   this.genieList = data?.supplierList;
    // });

  }
  setStatusBarBackgroundColor(color: string): void {
    const options: BackgroundColorOptions = {
      color,
    };
    StatusBar.setBackgroundColor(options);
  }
  async checkUser() {
    const endDate = formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss', this.locale);
    console.log(endDate);
    const payload = {
      startDate: "2021-01-01 00:00:00",
      endDate: endDate
    }
    this.naviService.getUsersList(payload).subscribe((data) => {
      if (data) {
        this.loggeedUser$.subscribe((user) => {
          console.log(user);
          const usersList = data?.users;
          const isUser = usersList.find(obj => obj.email == user.email);
          if (isUser) {
            localStorage.setItem(
              'user',
              JSON.stringify({
                mobileNumber: isUser?.mobileNumber,
                accountId: isUser?.accountId,
                email: isUser?.email,
                userName: isUser?.name,
                role: isUser?.role
              })
            );
            localStorage.setItem('loginType', 'Genie');
            this.dataService.machineId$.subscribe((genieId) => {
              if (genieId != 0) {
                this.router.navigate([`shop/machine-prod-items`], { skipLocationChange: true });
              }
              else {
                this.router.navigate(['shop/machines'], { skipLocationChange: true }); // Replace '/other-page' with the desired route
              }
            })
          }
          else {
            // make payload
            this.userForm.get('mobileNumber').setValue(1234567890);
            this.userForm.get('email').setValue(user.email);
            this.userForm.get('fName').setValue(user.name);
            this.isOtpVerified = true;
            this.registerUser();

          }
          this.isOtpVerified = false;
        })


      }
    })
  }
  onback() {
    this.showContent = false
  }
  onSignUp() {
    // const signUpModal = this.modalService.open(SignUpComponent, {
    //   ariaLabelledBy: "modal-basic-title",
    // });
    // signUpModal.componentInstance.actionEvent = "cart";

    this.showContent = !this.showContent;
    this.isLogin = true;
    this.isMobile = true;
    // this.auth
    //   .loginWithRedirect({
    //    redirect_uri: callbackUri,
    //     prompt: 'login',
    //     async openUrl(url: string) {
    //       console.log(url);
    //       return Browser.open({ url, windowName: '_self' });
    //     }
    //   });


  }
  onTerms_Conditions() {
    this.router.navigate(['pages/termsAndConditions'], { skipLocationChange: true })
  }
  OnCorporcateClick() {
    this.showContent = !this.showContent;
    this.selectedTabIndex = 1;
    this.isCorporateLogin = true;
    this.isLogin = false;
    this.isMobile = false;
  }
  onCorporateClose() {
    this.isCorporateLogin = false;
    this.isLogin = false;
    this.showContent = false
  }
  OnAboutPress() {

    this.router.navigate(['pages/aboutus'], { skipLocationChange: true })
  }
  onOtpChange(event: any) {
    this.userForm.controls['otp'].setValue(event);
  }
  verifyMobileNumber() {

    this.isMobileValid = this.userForm.controls['mobileNumber'].valid;
    if (!this.isMobileValid) return;
    else {

      const userData: userprofile = {};
      userData.userName = this.userForm.controls['mobileNumber'].value;
      userData.password = '';
      this.Mobilenumber = this.userForm.controls['mobileNumber'].value;
      this.naviService.loginValidate(userData).subscribe((data) => {
        console.log(data, typeof data.password);
        if (data?.isDeleted) {
          this._snackBar.open('Your account got deactivated please reach to support team.', 'X', {
            duration: 5000,
            panelClass: 'toast-message'
          });
          this.showContent = !this.showContent;
          this.userForm.controls['mobileNumber'].reset();
          return
        }
        if (data?.validUser) {
          this.isLogin = true;
          this.isNewUser = false;
          this.isMobile = true;
          this.currentUser.accountId = data?.accountId;
          this.currentUser.name = data?.userName;
          this.currentUser.email = data?.email;
          this.currentUser.role = data?.role;
          this.currentUser.mobileNumber = this.userForm.controls['mobileNumber'].value + "";
          this.currentUser.walletId = data?.walletId
          this.getOTP();
          this.startTimer();
          // if(!this.isProxyUser) {
          //   this.getOTP();
          //   this.startTimer();
          // } else {
          //   this.otpSent = true;
          // }
          console.log('Valid User.. Signing in...');
        } else if (!data?.validUser) {
          this.isLogin = true;
          this.isMobile = true;
          this.isNewUser = true;
          console.log('Not a Valid User');
        }
      });
    }
  }
  getOTP() {
    this.loading = true;
    const mobileNumber = this.userForm.controls['mobileNumber'].value;
    if (this.isNewUser) {
      // this.isEmailValid = this.userForm.controls['email'].valid;
      this.isMobileValid = this.userForm.controls['mobileNumber'].valid;
      this.isNameValid = this.userForm.controls['fName'].valid;
      if (!this.isMobileValid || !this.isNameValid) return
    }
    const userData = {
      action: "getOTP",
      receivedOTP: "",
      mobiles: "91" + mobileNumber,
      message: ""
    };
    this.naviService.getOTP(userData).subscribe((data) => {
      this.loading = false;
      if (data.type === 'success') {
        //this.showGetOTPBtn = false;
        //this.showVerifyOTPBtn = true;
        this.isOtpSent = true;

        this.startTimer();
      }
    });
  }
  verifyOTP() {
    this.loading = true;
    const otp = this.userForm.controls['otp'].value;
    const mobileNumber = this.userForm.controls['mobileNumber'].value;

    const userData = {
      action: "verifyOTP",
      receivedOTP: otp,
      mobiles: "91" + mobileNumber,
    };

    this.naviService.verifyOTP(userData).subscribe((data) => {
      this.isSubmitted = true;
      if (data.type === 'success') {
        this.isOtpVerified = true;
        console.log('login success', data);
        localStorage.setItem('jwtToken', JSON.stringify(data.jwtToken));
        if (this.isNewUser) {
          this.loading = false;

          this.registerUser();
        }
        else {
          this.loading = false;
          this.loginSuccess();
        }
      } else {
        console.log('login failure', this.isOtpVerified);
        this.isOtpVerified = false;
        this.loading = false;

      }
    });
  }
  registerUser() {

    const email = this.userForm.controls['email'].value;
    const mobileNumber = this.userForm.controls['mobileNumber'].value;
    const userName = this.userForm.controls['fName'].value;
    const userData: userprofile = {};

    userData.accountId = '0';
    userData.email = email; //this.user.email;
    userData.mobile = mobileNumber;
    userData.userName = userName;
    userData.password = "dummy";
    userData.mobileImei = '';
    userData.role = 'user';
    if (this.isOtpVerified) {
      // console.log("userData: ", userData);
      this.naviService.registerUser(userData).subscribe((data) => {
        // this.closeModal();
        console.log(data);
        localStorage.setItem('loginType', 'Genie');
        localStorage.setItem('jwtToken', JSON.stringify(data.jwtToken));
        localStorage.setItem(
          'user',
          JSON.stringify({
            mobileNumber: data.mobile,
            accountId: data?.accountId,
            email: data?.email,
            userName: data?.userName,
            role: data?.role
          })
        );
        let cartItem: cart = {};
        cartItem = JSON.parse(localStorage.getItem('payload'));

        console.log('cart item:', cartItem);
        if (cartItem) {
          cartItem.accountId = data?.accountId;
          this.naviService.postCartItem(cartItem).subscribe((data) => {
            cartItem.cartId = data.cartId;
            localStorage.setItem('payload', JSON.stringify(cartItem));
            this.router.navigate(["shop/mfg-land"], { skipLocationChange: true })
          });
        }
        const url = this.navService.getStoredUrl();
        if (url) {
          this.navService.setStoredUrl(null);
          this.router.navigate([`${url}`], { skipLocationChange: true });
        }
        else {
          this.router.navigate(["shop/mfg-land"], { skipLocationChange: true })
        }
        //window.location.reload();
      });
    }
  }
  overlayClick(event: Event) {
    // Prevent the click event from propagating to underlying elements
    if (this.loading) event.stopPropagation();
  }
  loginSuccess() {
    this.isOtpVerified = true;
    localStorage.setItem(
      'user',
      JSON.stringify({
        mobileNumber: this.currentUser?.mobileNumber,
        accountId: this.currentUser?.accountId,
        email: this.currentUser?.email,
        userName: this.currentUser?.name,
        role: this.currentUser?.role,
        walletId: this.currentUser?.walletId
      })
    );
    localStorage.setItem('loginType', 'Genie');
    let cartItem: cart = {};
    cartItem = JSON.parse(localStorage.getItem('payload'));
    console.log('cart item:', cartItem);


    if (cartItem) {
      cartItem.accountId = this.currentUser?.accountId;
      this.naviService.postCartItem(cartItem).subscribe((data) => {
        cartItem.cartId = data.cartId;
        localStorage.setItem('payload', JSON.stringify(cartItem));
        this.router.navigate(["shop/mfg-land"])
      });
    }
    const url = this.navService.getStoredUrl();
    if (url) {
      this.navService.setStoredUrl(null);
      this.router.navigate([`${url}`]);
    }
    else {
      this.router.navigate(["shop/mfg-land"])
    }

    // window.location.reload();

  }
  resendOTP() {
    this.isResendOtp = false;
    this.timeLeft = 60;
    this.startTimer();
    const mobileNumber = this.userForm.controls['mobileNumber'].value;
    const userData = {
      action: "resendOTP",
      receivedOTP: "",
      mobiles: "91" + mobileNumber,
      message: ""
    };
    this.naviService.resendOTP(userData).subscribe((data) => {
      if (data.otp) {
        this.isOtpSent = true;
        //this.showGetOTPBtn = false;
        //this.showVerifyOTPBtn = true;

      }
    });
  }
  checkOrganisation() {
    this.auth.loginWithRedirect({
      organization: this.stallCode,
      redirect_uri: callbackUri,
      async openUrl(url: string) {
        console.log(url);
        return Browser.open({ url, windowName: '_self' });
      }
    })
    // const genieObject = this.genieList.find((obj) => obj.stallCode === this.stallCode);

    // if (genieObject){
    //   this.isStallCodeValid = 'found';
    //   localStorage.setItem('loginType','Corporate');
    //   this.dataService.setMachineId(genieObject.stallid);
    //   localStorage.setItem("genieName", genieObject.name);
    //   this.dataService.UpdateGenieName(genieObject.name);
    //   this.router.navigateByUrl(`shop/machine-prod-items`, {skipLocationChange:true});
    // }
    //   else this.isStallCodeValid = 'invalid';
  }
  startTimer() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else if (this.timeLeft == 0) {
        this.isResendOtp = true;
        clearInterval(this.interval);
      }
    }, 1000)
  }
  async OpenScanner(modal) {
    if (Capacitor.getPlatform() != "web") {
      this.isMobileOrDesktop = true;
      const result = await Camera.requestPermissions();
      if (result.camera === 'granted') {
        console.log('Camera permissions granted.');
        // Proceed with camera operations
      } else {
        console.log('Camera permissions denied.');
        return
        // Handle the denied permissions
      }
    }
    else this.isMobileOrDesktop = false


    this.modalReference = this.modalService.open(modal, { keyboard: false, backdrop: 'static' });
    this.animateLine();
    // setTimeout(()=>{
    //   // Automatically triggering Integrated web cam button to open camera
    //     const buttons = document.querySelectorAll('.buttonDiv');
    //     console.log(buttons)

    //     if(this.isMobileOrDesktop){
    //      const targetElement = buttons[2].querySelector('.openCamera') as HTMLElement;
    //      targetElement.click();
    //     }
    //     else{
    //      const targetElement = buttons[1].querySelector('.openCamera') as HTMLElement;
    //      targetElement.click();
    //     }
    //    // Hiding Stop Camera button
    //     const hidebutton = document.querySelectorAll('.openCamera');
    //     Array.from(hidebutton).forEach(button => {
    //       this.renderer.setStyle(button, 'display', 'none');
    //     });      
    // },2000)

  }
  animateLine() {
    this.isContainerVisible = true;
    this.interval = setInterval(() => {
      this.linePosition += 1;
      if (this.linePosition >= 100) {
        this.linePosition = 0;
      }
    }, 10); // Adjust the interval as needed
  }
  capturedQr(result: string) {
    // this.isqrscanner=true;
    // alert(result);
    console.log(result);
    const scannedOrderId = result;

    this.qrCodeResult = result;
    this.isContainerVisible = false;
    this.getOrderDetails(result);

  }
  getOrderDetails(orderId) {
    const orderPayload: Orders = {};
    orderPayload.orderId = orderId;

    this.naviService.getOrderById(orderPayload).subscribe((data: Orders) => {
      if (data) {
        this.orderDetails = data;

        this.orderDetails.orderDateTime = formatDate(this.orderDetails.orderDateTime, 'yyyy-MM-dd HH:mm:ss',
          this.locale);

      }
    });
  }
  onError(error) {
    console.log(error);
  }
  OnClose() {
    this.modalReference.close();
    this.qrCodeResult = '';
    this.orderDetails = {};
    this.isContainerVisible = false;
    this.ngDestroy(this.interval);

  }
  ngDestroy(interval) {
    clearInterval(interval);
  }

}
